import _ from "lodash";
import { Module } from "vuex";
import { AutoCompletionsState } from "./types";
import { RootState } from "../../types";

import { getters, getterNames } from "./getters";
import { actions, actionNames } from "./actions";
import { mutations, mutationNames } from "./mutations";

const state = new AutoCompletionsState();

const namespaced: boolean = true;
const modul: Module<AutoCompletionsState, RootState> = {
  namespaced,
  getters,
  actions,
  mutations,
  state,
};

export const api = {
  namespace: "autocompletes",
  mutations: mutationNames,
  getters: getterNames,
  actions: actionNames,
};
export default modul;
